import { useState, useEffect } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide, } from 'swiper/react';
import axios from 'axios';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import RugbyHeader from './components/header/rugby-header';

import './main-rugby.css';

const srcpath = 'https://familyrugby.com/yt.json'

function MainRugby() {

    // const videos = [
    //             {
    //                 source: "https://www.youtube.com/embed/_qmGUa7E_Eg?si=vunuXkATQTgNYC65",
    //                 title: "Rugby Uzbekistan",
    //                 descr: "Description description description description description",
    //                 imgsrc: "../../img/rugby.jpg"
    //             },
    //             {
    //                 source: "https://www.youtube.com/embed/_qmGUa7E_Eg?si=vunuXkATQTgNYC65",
    //                 title: "Rugby Uzbekistan",
    //                 descr: "Description description description description description",
    //                 imgsrc: "../../img/rugby.jpg"
    //             },
    //             {
    //                 source: "https://www.youtube.com/embed/_qmGUa7E_Eg?si=vunuXkATQTgNYC65",
    //                 title: "Rugby Uzbekistan",
    //                 descr: "Description description description description description",
    //                 imgsrc: "../../img/rugby.jpg"
    //             },
    //             {
    //                 source: "https://www.youtube.com/embed/_qmGUa7E_Eg?si=vunuXkATQTgNYC65",
    //                 title: "Rugby Uzbekistan",
    //                 descr: "Description description description description description",
    //                 imgsrc: "../../img/rugby.jpg"
    //             },
    //             {
    //                 source: "https://www.youtube.com/embed/_qmGUa7E_Eg?si=vunuXkATQTgNYC65",
    //                 title: "Rugby Uzbekistan",
    //                 descr: "Description description description description description",
    //                 imgsrc: "../../img/rugby.jpg"
    //             },
    //             {
    //                 source: "https://www.youtube.com/embed/_qmGUa7E_Eg?si=vunuXkATQTgNYC65",
    //                 title: "Rugby Uzbekistan",
    //                 descr: "Description description description description description",
    //                 imgsrc: "../../img/rugby.jpg"
    //             },
    //             {
    //                 source: "https://www.youtube.com/embed/_qmGUa7E_Eg?si=vunuXkATQTgNYC65",
    //                 title: "Rugby Uzbekistan",
    //                 descr: "Description description description description description",
    //                 imgsrc: "../../img/rugby.jpg"
    //             }
    // ]

    const [articles, setArticles] = useState([]);

    useEffect(() => {
        axios
            .get(srcpath)
            .then(response => setArticles(response.data.videos))
            .catch(error => console.error("Ошибка при загрузке JSON:", error));
    }, []);




    const [setSwiperRef] = useState(null);
    // Create array with 500 slides
    // const [slides] = useState(
    //     Array.from({ length: 20 }).map((_, index) => `Slide ${index + 1}`)
    // );


    return (
        <div>
            <RugbyHeader />

            <section className="hero">
                <div className="container">
                    <div className="hero-info">
                        <div className="hero-background">
                            <div className="hero-background__title"><span>FAMILY</span> <br /> RUGBY TEAM</div>
                            <div className="hero-background__descr">Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed
                                repellendus recusandae eius, placeat nihil quisquam suscipit asperiores et. Dolorum illo
                                vitae accusamus explicabo itaque accusantium porro ipsam iure sapiente natus.
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed
                                repellendus recusandae eius, placeat nihil quisquam suscipit asperiores et. Dolorum illo
                                vitae accusamus explicabo itaque accusantium porro ipsam iure sapiente natus.
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed
                                repellendus recusandae eius, placeat nihil quisquam suscipit asperiores et.

                            </div>
                        </div>
                        <div className="news-tab">
                            <div className="tab first-tab"></div>
                            <div className="tab second-tab"></div>
                            <div className="tab third-tab"></div>
                        </div>
                    </div>

                </div>
            </section>

            <section className="yt-videos">
                <div className='container'>


                    <div className="carousel-box">
                        <div className="yt-videos_title">VIDEOS</div>
                        <Swiper
                            modules={[Navigation]}
                            onSwiper={setSwiperRef}
                            slidesPerView={3}
                            spaceBetween={30}
                            navigation={true}
                            rewind={true}
                            mousewheel={true}
                            loop={true}
                            className='swiper-parent'
                        >

                            {articles.map((article, index) => {
                                return (
                                    <SwiperSlide key={index}><iframe width="560" height="315" src={article.source} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </div>
            </section>
        </div >


    );
}




export default MainRugby;